import React, { useState, useEffect } from 'react';
import UpdateStatutoryBodyModalStyle from './UpdateStatutoryBodyModalStyle';
import HeaderText from '../../atoms/HeaderText/Text';
import Text from '../../atoms/Text/Text';
import Button from '../../atoms/Button/Button';
import Image from '../../atoms/Image/Img';
import close from '../../../assets/images/close.svg';
import Input from '../../atoms/Input/Input';
import { useDispatch, useSelector } from 'react-redux';
import { TypedDispatch, RootStore } from '../../../config/ConfigStore';
import { SubmitActionsPUT } from '../../../redux/actions/SubmitAction';
import { alertActions } from '../../../redux/actions/AlertActions';
import { appInstance as axios } from '../../../axios';
import Cookies from 'js-cookie';
import closeIcon from '../../../assets/images/close-icon-round.svg';
import dropdown from '../../../assets/images/dropdown.svg';
import caret from '../../../assets/images/caret-down-select.svg';

type UpdateStatutoryBodyModalProps = {
  handleClose: Function,
  reloadPage: Function,
  data: any
}

const UpdateStatutoryBodyModal = ({ handleClose, reloadPage, data }: UpdateStatutoryBodyModalProps) => {
  const dispatch: TypedDispatch = useDispatch();
  const state = useSelector((state: RootStore) => state);
  const [fields, setFields] = useState({
    name: data.name,
    description: data.description,
    email: data.contactEmail,
    phoneNumber: data.contactPhone,
    institutionCode: data.code,
    category: data.category,
    bank: data.settlementDetails.issuerCode,
    accountNumber: data.settlementDetails.settlementAccount
  });
  const [checking, setChecking] = useState(false);
  const [accountName, setAccountName] = useState("");
  const [accountError, setAccountError] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [bankList, setBankList] = useState([]);


  useEffect(() => {
    if (state.submitReducer.results && submitted) {
      handleClose();
      reloadPage();
    }
  }, [state.submitReducer])

  useEffect(() => {
    generatePageContent();
  }, [])

  const generatePageContent = async () => {
    try {
      const res = await axios.get(`/payroll/configuration/issuers?size=0&page=1`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Cookies.get("userToken")}`
        }
      });
      setBankList(res.data.data.content);
    } catch (error: any) {
      if (error.message === "Network Error") {
        dispatch(alertActions.error('Network Error, try again!!!'));
      } else {
        dispatch(alertActions.error(error.response.data.error));
      }
    }
  }

  const inputChange = async (name: string, value: string) => {
    const fieldsValues: any = Object.assign({}, fields);
    fieldsValues[name] = value;
    await setFields(fieldsValues);
  };

  const onFormSubmit = () => {
    return (e: React.FormEvent) => {
      e.preventDefault();
      setSubmitted(true);
      const defaultValues:{
        [key: string]: any
      } = {
        "code": data.code,
        "name": data.name,
        "description": data.description,
        "contactEmail": data.contactEmail,
        "contactPhone": data.contactPhone,
        "category": data.category,
        "settlementDetails": {
          "issuerCode": data.settlementDetails.issuerCode,
          "settlementAccount": data.settlementDetails.settlementAccount
        },
      }
      const newValues:{
        [key: string]: any
      } = {
        "code": fields.institutionCode,
        "name": fields.name,
        "description": fields.description,
        "contactEmail": fields.email,
        "contactPhone": fields.phoneNumber,
        "category": fields.category,
        "settlementDetails": {
          "issuerCode": fields.bank,
          "settlementAccount": fields.accountNumber
        },
      }
      let diff = Object.keys(newValues).reduce((diff, key) => {
        if (defaultValues[key] === newValues[key]) return diff
        return {
          ...diff,
          [key]: newValues[key]
        }
      }, {})
      dispatch(SubmitActionsPUT(`/payroll/configuration/partners/${data.id}`, diff))
    }
  }

  const getAccountName = async () => {
    const payload = {
      "accountNumber": fields.accountNumber,
      "issuerCode": fields.bank,
      "entity": 2,
    }
    try {
      setChecking(true);
      const res = await axios.post(`/account/enquiry`, payload, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Cookies.get("userToken")}`
        }
      });
      setChecking(false);
      if(res.data.data.isValidated === 0){
        setAccountError(true);
      }
      else{
        setAccountError(false);
      }
      setAccountName(res.data.data.validatedName);
    } catch (error: any) {
      setChecking(false);
      if (error.message === "Network Error") {
        dispatch(alertActions.error('Network Error, try again!!!'));
      } else {
        dispatch(alertActions.error(error.response.data.error));
      }
    }
  }

  return (
    <UpdateStatutoryBodyModalStyle className={`container-full`}>
      <div className={`container-full center modal-container`}>
        <div className={`modal-container__box`}>
          <div className={`container-full modal-container__box__header`}>
            <HeaderText value='Update Statutory Body' />
            <Image image={close} onClick={() => handleClose()} />
          </div>
          <form onSubmit={onFormSubmit()}>
            <div className={`container-full modal-container__box__content`}>
              <div className={`container-full modal-container__box__content__desc`}>
                <HeaderText value='Update information for this Statutory Body.' />
              </div>
              <div className={`container-full modal-container__box__content__form`}>
                <div className={`container-full modal-container__box__content__form__item`}>
                  <p> Name <span>*</span></p>
                  <Input type='text' className="input" placeholder="Eg Retail Corporate Ltd" required name="name" value={fields.name} onChange={(e) => inputChange(e.target.name, e.target.value)} />
                </div>
                <div className={`container-full modal-container__box__content__form__item`}>
                  <Text value='Description' />
                  <Input type='text' className="input" placeholder="Add a description here" name="description" value={fields.description} onChange={(e) => inputChange(e.target.name, e.target.value)} />
                </div>
                <div className={`container-full modal-container__box__content__form__item`}>
                  <div className='div-md-6'>
                    <p> Email <span>*</span></p>
                    <Input type='email' className="input" placeholder="Eg. maggiesmitthoie@gmail.com" required name="email" value={fields.email} onChange={(e) => inputChange(e.target.name, e.target.value)} />
                  </div>
                  <div className='div-md-6'>
                    <p> Phone Number <span>*</span></p>
                    <Input type='text' className="input" placeholder="Eg. 2348024044353" required name="phoneNumber" value={fields.phoneNumber} onChange={(e) => inputChange(e.target.name, e.target.value)} />
                  </div>
                </div>
                <div className={`container-full modal-container__box__content__form__item`}>
                  <div className='div-md-6'>
                    <p> Institution Code <span>*</span></p>
                    <Input type='text' className="input disabled" placeholder="Eg. 023" required name="institutionCode" value={fields.institutionCode} onChange={(e) => inputChange(e.target.name, e.target.value)} />
                  </div>
                  <div className='div-md-6'>
                    <p> Category <span>*</span></p>
                    <div className='input disabled'>
                      <select required
                        name="category"
                        onChange={(evt) => inputChange(evt.target.name, evt.target.value)}
                        value={fields.category}
                      >
                        <option value="" hidden> Select Category </option>
                        {
                          (data.category === 1) ? <option value="1"> PAYE </option> : null
                        }
                        {
                          (data.category === 2) ? <option value="2"> NHIS </option>  : null
                        }
                        {
                          (data.category === 3) ? <option value="3"> NHF </option> : null
                        }
                        {
                          (data.category === 4) ? <option value="4"> PFA </option> : null
                        }
                      </select>
                      <Image image={caret} />
                    </div>
                  </div>
                </div>
              </div>
              <div className={`container-full modal-container__box__content__desc2`}>
                <HeaderText value='Settlement Account Details' />
              </div>
              <div className={`container-full modal-container__box__content__form`}>
                <div className={`container-full modal-container__box__content__form__item`}>
                  <div className='div-md-6'>
                    <p> Bank <span>*</span></p>
                    <div className='input'>
                      <select required
                        name="bank"
                        onChange={(evt) => inputChange(evt.target.name, evt.target.value)}
                        value={fields.bank}
                      >
                        <option value="" hidden> Select Bank </option>
                        {
                          (bankList.length > 0 && bankList.map((bank: Record<any, any>) => {
                            return (<option value={bank.issuerCode} key={bank.id}> {bank.name} </option>)
                          }))
                        }
                      </select>
                      <Image image={caret} />
                    </div>
                    {
                      (fields.bank !== "") ? 
                      <div className='modal-container__box__content__form__item__label' onClick={() => getAccountName()}>
                        <Text value='Get Account Name' />
                      </div> : null
                    }  
                  </div>
                  <div className='div-md-6'>
                    <p> Account Number <span>*</span></p>
                    <Input type='text' className="input" placeholder="Enter Account Number" required name="accountNumber" value={fields.accountNumber} onChange={(e) => inputChange(e.target.name, e.target.value)} />
                    {
                      (fields.bank !== "") ? 
                      <>
                        {
                          (!accountError && accountName !== "" && !checking) ? <h4 className="info"> {accountName} </h4> : null
                        }
                        {
                          (accountError && !checking) ? <h4 className='error'> Account Name Retreival Error </h4> : null
                        }
                      </> : null
                    }
                  </div>
                </div>
              </div>
            </div>
            <div className={`container-full center modal-container__box__action`}>
              <Button type="button" value="Cancel" className={`button --cancel`} onClick={() => handleClose()} />
              <Button type="submit" value="Update" className={`button --change --active-btn`} isLoading={state.submitReducer.fetching} />
            </div>
          </form>
        </div>
      </div>
    </UpdateStatutoryBodyModalStyle>
  );
}

export default UpdateStatutoryBodyModal;